import { BTX_COMMISSION_PREPOPULATION } from "@platform/feature-flags";
import { FeatureFlagBoundary } from "@platform/fe-utils";
import { JSX } from "react";

import LegacyCommissionSection from "../commissionSection";

import {
  NormalizedCommissionSection,
  NormalizedCommissionSectionProps,
} from "./NormalizedCommissionSection";

export interface CommissionSectionProps extends NormalizedCommissionSectionProps {
  handlePlanFormChangeWithValidation?: (target: unknown, plan: string) => void;
  handlePreviousFieldsValidation?: (field: string, plan: string) => void;
}

/**
 * Commission entry for a coverage plan.
 *
 * The same flag gates BTX's consumption of these values, so the normalized
 * fields and the Build Tab that reads them turn on together.
 */
export const CommissionSection = (
  props: CommissionSectionProps,
): JSX.Element => (
  <FeatureFlagBoundary
    flag={BTX_COMMISSION_PREPOPULATION}
    fallback={<LegacyCommissionSection {...props} />}
  >
    <NormalizedCommissionSection {...props} />
  </FeatureFlagBoundary>
);
